import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Newspaper, Building2, LogOut, LayoutGrid, Library, Compass } from "lucide-react";

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const navLink = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors rounded-md ${
      isActive ? "bg-zinc-800 text-zinc-50" : "text-zinc-400 hover:text-zinc-50 hover:bg-zinc-900"
    }`;

  return (
    <div className="min-h-screen flex bg-zinc-950 text-zinc-50">
      <aside className="w-64 border-r border-zinc-800 flex flex-col p-4 gap-1 shrink-0">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 px-2 py-3 mb-2">
          <div className="w-8 h-8 bg-blue-600 rounded-md grid place-items-center font-display font-bold text-white">
            AJ
          </div>
          <div>
            <div className="font-display text-lg leading-none">Ad Journal</div>
            <div className="label-eyebrow !text-[9px]">Generator</div>
          </div>
        </Link>
        <div className="label-eyebrow px-3 mt-4 mb-1">Workspace</div>
        <NavLink to="/dashboard" data-testid="nav-dashboard" className={navLink}>
          <LayoutGrid className="w-4 h-4" /> Journals
        </NavLink>
        <NavLink to="/companies" data-testid="nav-companies" className={navLink}>
          <Building2 className="w-4 h-4" /> Companies
        </NavLink>
        <NavLink to="/caption-libraries" data-testid="nav-caption-libraries" className={navLink}>
          <Library className="w-4 h-4" /> Caption libraries
        </NavLink>
        <NavLink to="/explore" data-testid="nav-explore" className={navLink}>
          <Compass className="w-4 h-4" /> Explore
        </NavLink>

        <div className="mt-auto flex flex-col gap-2 pt-4 border-t border-zinc-800">
          {user && typeof user === "object" && (
            <div data-testid="user-info" className="px-3 text-xs">
              <div className="text-zinc-50 font-medium truncate">{user.name || user.email}</div>
              <div className="text-zinc-500 truncate">{user.email}</div>
            </div>
          )}
          <button
            data-testid="logout-btn"
            onClick={async () => {
              await logout();
              nav("/login");
            }}
            className="flex items-center gap-2 text-sm text-zinc-400 hover:text-red-400 px-3 py-2 rounded-md hover:bg-zinc-900"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 overflow-y-auto">
        {children}
      </main>
    </div>
  );
}
